interface StateType {
    kv: string;
    tab1Background: string;
    tab2Background: string;
    tab1: string;
    tab2: string;
    award1: string;
    award2: string;
    award3: string;
    award4: string;
    award5: string;
    award1_g: string;
    award2_g: string;
    award3_g: string;
    award4_g: string;
    award5_g: string;
    btn: string;
}
type stateKey = keyof StateType;

interface PayloadType {
    key: stateKey;
    value: string;
}

export default {
    state: {
        kv: '',
        tab1Background: '',
        tab2Background: '',
        tab1: '',
        tab2: '',
        award1: '',
        award2: '',
        award3: '',
        award4: '',
        award5: '',
        award1_g: '',
        award2_g: '',
        award3_g: '',
        award4_g: '',
        award5_g: '',
        btn: ''
    },
    mutations: {
        setBackgrondValue(state: StateType, playLoad: PayloadType) {
            const { key, value } = playLoad;
            if (state[key]) return;
            state[key] = value;
        }
    },

    namespaced: true
};
